import moment from 'moment';

import ClientStorage from '@fec/frontend/foundation/client/storage';
import { APP_ID_RECEIVED, onEvent } from '@fec/assets/js/utils/event';

const APP_ID_IOS = 'srf-app-meteo-ios';
const APP_ID_ANDROID = 'srf-app-meteo-android';

const NEWS_BANNER_DISMISSED = 'srf:newsAppBanner:dismissed';
const METEO_BANNER_DISMISSED = 'srf:meteoAppBanner:dismissed';
const PLAY_RTR_BANNER_DISMISSED = 'srf:playRtrAppBanner:dismissed';

const DAYS_WAITING = 4;

const showNewsBanner = (appId) => {
  if (appId === APP_ID_IOS || appId === APP_ID_ANDROID) {
    showBanner('news');
  }
};

const showBanner = (app) => {
  document
    .querySelectorAll(`.js-promo-banner[data-app="${app}"]`)
    .forEach((el) => el.classList.remove('h-element--hide'));
};

const removeBanner = (app) => {
  document
    .querySelectorAll(`.js-promo-banner[data-app="${app}"]`)
    .forEach((el) => el.remove());
};

const removeIfDismissedBefore = () => {
  const checkAndRemoveBanner = (storageKey, app) => {
    const dismissal = ClientStorage.getItem(storageKey, false);
    if (dismissal) {
      const dismissedAt = moment(dismissal);
      const now = moment();

      if (now.diff(dismissedAt, 'days', true) < DAYS_WAITING) {
        removeBanner(app);
      }
    }
  };

  checkAndRemoveBanner(METEO_BANNER_DISMISSED, 'meteo');
  checkAndRemoveBanner(NEWS_BANNER_DISMISSED, 'news');
  checkAndRemoveBanner(PLAY_RTR_BANNER_DISMISSED, 'play-rtr');
};

const markAsDismissed = (app) => {
  const timestamp = moment().format();
  switch (app) {
    case 'meteo':
      ClientStorage.setItem(METEO_BANNER_DISMISSED, timestamp);
      break;
    case 'news':
      ClientStorage.setItem(NEWS_BANNER_DISMISSED, timestamp);
      break;
    case 'play-rtr':
      ClientStorage.setItem(PLAY_RTR_BANNER_DISMISSED, timestamp);
      break;
    default:
      // dunno lol
      break;
  }
};

const setUpCloseButtonHandler = () => {
  // click on a close button hides the containing promo banner
  document
    .querySelectorAll('.js-promo-banner')
    .forEach((promoBannerElement) => {
      promoBannerElement.addEventListener('click', (event) => {
        // make sure we only handle clicks on the close button or its children
        if (
          event.target.matches(
            '.js-promo-banner-close, .js-promo-banner-close *',
          )
        ) {
          markAsDismissed(promoBannerElement.dataset.app);
          // hide, not remove, so the tracking call can still be made
          promoBannerElement.classList.add('h-element--hide');
        }
      });
    });
};

const showNewsBannerIfInMeteoApp = () => {
  const newsAppBannerDismissed = ClientStorage.getItem(
    NEWS_BANNER_DISMISSED,
    false,
  );

  if (newsAppBannerDismissed) {
    return;
  }

  // news banner should be shown if the bridge reports that we're in the meteo app
  const appId = ClientStorage.getItem('srf:appId');

  // either app is already initialized (and we know the appId)
  // or we wait for the appId to be received:
  if (appId) {
    showNewsBanner(appId);
  } else {
    onEvent({
      eventName: APP_ID_RECEIVED,
      eventHandler: ({ appId }) => showNewsBanner(appId),
    });
  }
};

export function init() {
  // remove all banners completely from the DOM if they were already dismissed
  removeIfDismissedBefore();

  // for the remaining banners: set up the close button handler(s)
  setUpCloseButtonHandler();

  // show the news banner if we're in the meteo app
  showNewsBannerIfInMeteoApp();

  // show the meteo banner (if it wasn't removed before)
  showBanner('meteo');

  // show the Play RTR banner (if it wasn't removed before)
  showBanner('play-rtr');
}
